module.exports = __webpack_public_path__ + "img/association_1_1.c8fcce60.png";